import {
  Box,
  Button,
  Paper,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import type { AcademyLesson } from '../../../pages/academy/Academy/AcademyService';
import { StatusBadge } from '../AcademyStatus/AcademyStatus';
import { isConfirmed } from '../Utilities/academyLabels';
import { getAcademyMaskedIconStyle } from '../Utilities/academyMaskedIcon';
import { getAcademyPathIconUrl } from '../Utilities/academyPathIcons';
import { academyStyles } from '../../../pages/academy/Academy/Academy.styles';
import { recommendedLessonsClassNames } from './RecommendedLessons.styles';

export interface RecommendedLessonsProps {
  lessons: AcademyLesson[];
  onOpenSkill: (skillKey: string) => void;
}

export function RecommendedLessons({
  lessons,
  onOpenSkill,
}: RecommendedLessonsProps) {
  const theme = useTheme();

  return (
    <Box
      component="section"
      className={recommendedLessonsClassNames.root}
      sx={academyStyles.section()}
      aria-labelledby="recommended-title"
    >
      <Typography
        id="recommended-title"
        component="h2"
        variant="h2"
        sx={academyStyles.sectionTitle()}
      >
        Recommended Next Lessons
      </Typography>
      <Box className={recommendedLessonsClassNames.grid} sx={academyStyles.cardGrid(theme)}>
        {lessons.map((lesson) => {
          const pathIconUrl = getAcademyPathIconUrl(lesson.pathKey);

          return (
            <Paper
              component="article"
              className={recommendedLessonsClassNames.card}
              sx={academyStyles.lessonCard()}
              key={lesson.id}
              elevation={0}
            >
              <Box sx={academyStyles.lessonHeading()}>
                <Box component="span" sx={academyStyles.pathIcon(theme, true)} aria-hidden="true">
                  <Box
                    component="span"
                    sx={academyStyles.pathIconImage()}
                    style={getAcademyMaskedIconStyle(pathIconUrl)}
                  />
                </Box>
                <Typography component="h3" sx={academyStyles.cardTitle()}>
                  {lesson.title}
                </Typography>
              </Box>
              <Typography sx={academyStyles.lessonDescription()}>{lesson.description}</Typography>
              <Box sx={academyStyles.lessonActions()}>
                <Button
                  sx={academyStyles.lessonActionButton(theme)}
                  type="button"
                  disableRipple
                  onClick={() => onOpenSkill(lesson.skillKey)}
                >
                  {isConfirmed(lesson.learnConfirmedBy) ? 'Open' : 'Start'}
                </Button>
                <StatusBadge label="Learned" confirmedBy={lesson.learnConfirmedBy} />
                <StatusBadge label="Applied" confirmedBy={lesson.applyConfirmedBy} />
              </Box>
            </Paper>
          );
        })}
      </Box>
    </Box>
  );
}
